/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import ArrowIcon from "@mui/icons-material/ArrowForwardIos";
import ICompAnalysis from "../../../types/ICompAnalysis";

const FreightBox = ({
  record,
  toggleFreightDetails,
  toggleFreightDetailPanel,
}: {
  record: ICompAnalysis;
  toggleFreightDetails: () => void;
  toggleFreightDetailPanel: () => void;
}) => {
  if (record.freight === 0) {
    return (
      <div
        id="freightBox"
        style={{
          height: 70,
          width: 70,
          borderRadius: 33,
          backgroundColor: "#ECEDEF",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          fontSize: 14,
        }}
      >
        Ask Logistics
      </div>
    );
  }

  if (record.mode === "RAIL" && !record.isValid) {
    return (
      <div
        id="freightBox"
        style={{
          position: "relative",
          height: 80,
          width: 100,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          cursor: "pointer",
        }}
        onClick={() => {
          toggleFreightDetailPanel();
        }}
      >
        {/* Connecting line */}
        <div
          style={{
            position: "absolute",
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            display: "flex",
            alignItems: "center",
          }}
        >
          <div style={{ height: 3, backgroundColor: "#D9D9D9", flexGrow: 1 }} />
        </div>

        <div
          style={{
            position: "absolute",
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <svg
            width="80"
            height="90"
            viewBox="0 0 50 42"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M48.2132 19.9692C48.5946 20.6035 48.5946 21.3965 48.2132 22.0308L37.5174 39.8154C37.1557 40.4168 36.5053 40.7846 35.8035 40.7846H14.1965C13.4947 40.7846 12.8443 40.4168 12.4826 39.8154L1.78682 22.0308C1.40538 21.3965 1.40538 20.6035 1.78682 19.9692L12.4826 2.18463C12.8443 1.58322 13.4947 1.21539 14.1965 1.21539H35.8035C36.5053 1.21539 37.1557 1.58322 37.5174 2.18463L48.2132 19.9692Z"
              fill="#FFE7E7"
              stroke="#FF4646"
              strokeWidth="2"
            />
          </svg>
        </div>
        <div
          style={{
            position: "absolute",
            top: 10,
            bottom: 0,
            left: 0,
            right: 0,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: 2,
            zIndex: 1,
          }}
        >
          <div style={{ fontSize: 15 }}>{`$${(
            record?.freight || 0
          ).toLocaleString()}`}</div>
          <div style={{ height: 12, maxHeight: 12, paddingTop: 2 }}>
            <div
              style={{
                fontSize: 10,
                color: "#005CA6",
                display: "flex",
                alignItems: "center",
              }}
            >
              Freight
              <ArrowIcon style={{ fontSize: 10, color: "#005CA6" }} />
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      id="freightBox"
      style={{
        height: 70,
        width: 70,
        borderRadius: 33,
        backgroundColor: "#ECEDEF",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        cursor: "pointer",
      }}
      onClick={() => {
        if (record.mode === "RAIL") {
          toggleFreightDetailPanel();
        } else {
          toggleFreightDetails();
        }
      }}
    >
      <div>{`$${(record?.freight || 0).toLocaleString()}`}</div>
      <div style={{ height: 12, maxHeight: 12, paddingTop: 2 }}>
        <div
          style={{
            fontSize: 10,
            color: "#005CA6",
            display: "flex",
            alignItems: "center",
          }}
        >
          Freight
          <ArrowIcon style={{ fontSize: 10, color: "#005CA6" }} />
        </div>
      </div>
    </div>
  );
};

export default FreightBox;
